// const isDev = process.env.NODE_ENV === 'development' ? true : false
const isDev = false
export default {
    baseURL: isDev ? 'http://yeshanpo.t.tuliyou.com/' : 'https://ts.hbysp.cn/',
    basePath: 'api.php/v1/',
    v5: 'api.php/v5/',
	scenicBasePath: 'api.php/v5_scenic/',
    bmapServiceURL: 'https://api.map.baidu.com/',
    bmapServiceKey: 'kHG3BHVtt4r5FzQBPji8Ku0j'
}

